import React from 'react';
import { Box, Text, useColorModeValue } from '@chakra-ui/react';
import { TransactionStatus } from '@Encore-FastStartup-Phase-Out/encore-shared';

import { Colors } from '../../theme/colors';

type PillProps = {
  status: TransactionStatus;
};

const TransactionStatusPill = ({ status }: PillProps) => {
  const textColorSuccess = useColorModeValue(
    Colors.light.primary,
    Colors.dark.primary,
  );
  const textColorError = useColorModeValue(
    Colors.light.error,
    Colors.dark.error,
  );

  return (
    <Box
      display="inline-block"
      px={'20px'}
      py={'4px'}
      bg={'transparent'}
      color="white"
      borderRadius="full"
      border={`1px solid ${status === TransactionStatus.Succeeded ? textColorSuccess : textColorError}`}
    >
      <Text
        color={
          status === TransactionStatus.Succeeded
            ? textColorSuccess
            : textColorError
        }
      >
        {status === TransactionStatus.Succeeded ? 'Succeeded' : 'Failed'}
      </Text>
    </Box>
  );
};

export default TransactionStatusPill;
